import { render, staticRenderFns } from "./ComarcaSelect.vue?vue&type=template&id=62b2febf&"
import script from "./ComarcaSelect.vue?vue&type=script&lang=js&"
export * from "./ComarcaSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports